import { useState, useEffect } from "react";
import "./admin.css";
import { NavLink } from "react-router-dom";

const API = "https://suivi.amservices.eu/api";

export default function Admin() {
    const [reparations, setReparations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [smsModal, setSmsModal] = useState({ open: false, id: null, message: "", client: "", telephone: "" });
    const [smsSending, setSmsSending] = useState(false);
    const [appareils, setAppareils] = useState(["PC Portable", "PC Fixe", "MacBook", "iMac", "Smartphone", "Tablette", "Switch", "PS4/PS5", "Xbox", "Imprimante"]);
    const [selectedAppareils, setSelectedAppareils] = useState([]);
    const [selectedAppareil, setSelectedAppareil] = useState("");
    const [newAppareil, setNewAppareil] = useState("");
    const [showOtherInput, setShowOtherInput] = useState(false);

    const loadReparations = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API}/get_reparations.php`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setReparations(data.data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadReparations(); }, []);
    const copyForDymo = (rep) => {
        // On prépare le texte avec les infos : Réf, Client, Appareils, MDP et NOTES
        const text = `Réf: ${rep.reference}\nClient: ${rep.client}\nAppareils: ${rep.appareils.join(", ")}\nMDP: ${rep.password_client || "-"}\nNotes: ${rep.note || "-"}`;

        navigator.clipboard.writeText(text).then(() => {
            // Optionnel : tu peux remplacer l'alert par un petit message temporaire plus discret
            alert("Infos copiées (Notes incluses) !");
        }).catch(err => {
            console.error("Erreur lors de la copie : ", err);
        });
    };
    const SMS_TEMPLATES = {
        pris_en_charge: "Votre matériel est bien pris en charge par AM Services. Son suivi est assuré et vous serez informé par SMS dès qu’il sera prêt pour enlèvement.",
        diagnostic: "Votre appareil est en diagnostic dans notre atelier AM Services. Dès l’analyse terminée, un SMS vous indiquera la prochaine étape.",
        pieces_commandees: "Les pièces nécessaires ont été commandées. Dès leur réception fournisseur, elles seront intégrées au montage et un SMS vous signalera l’étape suivante.",
        pieces_recues: "Les pièces sont reçues et le montage est en cours dans notre atelier. Une fois l’assemblage finalisé, un SMS vous indiquera la prochaine étape.",
        termine: "Votre machine est prête à l’enlèvement. Vous pouvez venir la récupérer dès à présent chez AM Services.",
        avis: "Votre avis compte ! Si vous êtes satisfait, laisser un avis Google nous aide énormément. Merci pour votre soutien."
    };

    // MISE À JOUR DYNAMIQUE (Client, Tel, Notes, MDP)
    const updateField = async (id, field, value) => {
        await fetch(`${API}/update_field.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id, field, value })
        });
    };

    const updateEtat = async (id, etat, rep) => {
        setReparations(p => p.map(r => r.id === id ? { ...r, etat } : r));
        await fetch(`${API}/update_etat.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id, etat })
        });
        if (SMS_TEMPLATES[etat]) {
            setSmsModal({ open: true, id, client: rep.client, telephone: rep.tel, message: SMS_TEMPLATES[etat] });
        }
        loadReparations();
    };

    const archive = async (id) => {
        if (!window.confirm("Archiver cette réparation ?")) return;
        await fetch(`${API}/archive.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id })
        });
        loadReparations();
    };

    const confirmSendSMS = async () => {
        if (smsSending || !smsModal.message.trim()) return;
        setSmsSending(true);
        try {
            const response = await fetch(`${API}/sms.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ id: smsModal.id, message: smsModal.message, include_tracking: true })
            });
            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.message || "Échec de l'envoi du SMS");
            }
            setSmsModal({ ...smsModal, open: false });
            alert("SMS envoyé ✔");
        } catch (error) {
            alert(error.message || "Impossible d'envoyer le SMS");
        } finally {
            setSmsSending(false);
        }
    };

    const addAppareil = (v) => {
        if (!v || v === "-- Appareil --") return;
        if (v === "autre") return setShowOtherInput(true);
        if (!selectedAppareils.includes(v)) setSelectedAppareils(p => [...p, v]);
        setSelectedAppareil("");
    };

    const addCustomAppareil = () => {
        if (!newAppareil.trim()) return;
        setAppareils(p => [...p, newAppareil.trim()]);
        setSelectedAppareils(p => [...p, newAppareil.trim()]);
        setNewAppareil("");
        setShowOtherInput(false);
    };

    const addClient = async () => {
        const nom = document.getElementById("nomClient").value.trim();
        const tel = document.getElementById("telClient").value.trim();
        const note = document.getElementById("noteClient").value.trim();
        const password_client = document.getElementById("passwordClient").value.trim();

        if (!nom || !tel || selectedAppareils.length === 0) return alert("Champs incomplets");

        const response = await fetch(`${API}/add_reparation.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ client: nom, tel, note, password_client, appareils: selectedAppareils })
        });
        const data = await response.json();
        if (!response.ok || !data.success) {
            return alert(data.message || "Impossible de créer la réparation");
        }

        setSelectedAppareils([]);
        setShowModal(false);
        loadReparations();
        alert(data.sms_sent
            ? "Réparation créée et SMS de suivi envoyé ✔"
            : `Réparation créée, mais SMS non envoyé : ${data.sms_error || "erreur inconnue"}`);
    };

    return (
        <div className="admin-page">
            <h1>🔧 Gestion réparations</h1>

            <div className="top-actions">
                <button className="btn-add" onClick={() => setShowModal(true)}>+ Ajouter</button>
                <NavLink to="/admin/archives" className="btn-archive-link">📦 Archives</NavLink>
            </div>

            {loading && <p style={{ textAlign: 'center' }}>Chargement...</p>}

            <table className="repair-table">
                <thead>
                    <tr>
                        <th>Réf</th>
                        <th>Client</th>
                        <th>Tel</th>
                        <th>Appareils</th>
                        <th>Notes</th>
                        <th>MDP</th>
                        <th>État</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {reparations.map(rep => (
                        <tr key={rep.id}>
                            {/* RÉFÉRENCE : TEXTE SIMPLE (BLOQUÉ) */}
                            <td data-label="Réf">
                                <span className="ref-badge">{rep.reference}</span>
                            </td>

                            <td data-label="Client">
                                <input
                                    type="text"
                                    className="input-inline"
                                    defaultValue={rep.client}
                                    onBlur={e => updateField(rep.id, 'client_nom', e.target.value)}
                                />
                            </td>
                            <td data-label="Tel">
                                <input
                                    type="text"
                                    className="input-inline"
                                    defaultValue={rep.tel}
                                    onBlur={e => updateField(rep.id, 'client_tel', e.target.value)}
                                />
                            </td>
                            <td data-label="Appareils">{rep.appareils.join(", ")}</td>
                            <td data-label="Notes">
                                <textarea
                                    defaultValue={rep.note}
                                    onBlur={e => updateField(rep.id, 'note', e.target.value)}
                                />
                            </td>
                            <td data-label="MDP">
                                <input
                                    type="text"
                                    className="input-inline"
                                    defaultValue={rep.password_client}
                                    onBlur={e => updateField(rep.id, 'password_client', e.target.value)}
                                    placeholder="-"
                                />
                            </td>
                            <td data-label="État">
                                <select value={rep.etat} onChange={e => updateEtat(rep.id, e.target.value, rep)}>
                                    <option value="pris_en_charge">Pris en charge</option>
                                    <option value="diagnostic">Diagnostic</option>
                                    <option value="pieces_commandees">Pièces commandées</option>
                                    <option value="pieces_recues">Pièces reçues</option>
                                    <option value="termine">Terminé</option>
                                    <option value="recupere">Récupéré</option>
                                </select>
                            </td>
                            <td data-label="Actions" className="actions-menu">
                                {/* Copier pour Dymo */}
                                <button onClick={() => copyForDymo(rep)} title="Copier pour Dymo">📋</button>

                                {/* Envoyer un SMS manuel */}
                                <button
                                    onClick={() => setSmsModal({ open: true, id: rep.id, client: rep.client, telephone: rep.tel, message: `Bonjour ${rep.client}, votre réparation avance !` })}
                                    title="Envoyer un SMS"
                                >
                                    📩
                                </button>

                                {/* Archiver la réparation */}
                                <button onClick={() => archive(rep.id)} title="Archiver la réparation">📦</button>

                                {/* Demander un avis Google */}
                                <button
                                    onClick={() => setSmsModal({ open: true, id: rep.id, client: rep.client, telephone: rep.tel, message: SMS_TEMPLATES.avis })}
                                    title="Demander un avis Google"
                                >
                                    ⭐
                                </button>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>

            {/* MODAL AJOUT */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Nouvelle réparation</h2>
                        <input id="nomClient" placeholder="Nom" />
                        <input id="telClient" placeholder="Téléphone" />
                        <input id="passwordClient" placeholder="Mot de passe client" />
                        <div className="tags-container">
                            {selectedAppareils.map((a, i) => (
                                <div key={i} className="tag">{a} <span onClick={() => setSelectedAppareils(p => p.filter(x => x !== a))}>×</span></div>
                            ))}
                        </div>
                        <select value={selectedAppareil} onChange={e => { setSelectedAppareil(e.target.value); addAppareil(e.target.value); }}>
                            <option>-- Appareil --</option>
                            {appareils.filter(a => !selectedAppareils.includes(a)).map((a, i) => <option key={i}>{a}</option>)}
                            <option value="autre">Autre...</option>
                        </select>
                        {showOtherInput && (
                            <div className="row">
                                <input value={newAppareil} onChange={e => setNewAppareil(e.target.value)} placeholder="Nom appareil" />
                                <button onClick={addCustomAppareil}>+</button>
                            </div>
                        )}
                        <textarea id="noteClient" placeholder="Notes (problème, état...)" />
                        <div className="modal-actions">
                            <button onClick={() => setShowModal(false)} className="btn-cancel">Annuler</button>
                            <button className="btn-submit" onClick={addClient}>Valider</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL SMS */}
            {smsModal.open && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>📩 SMS pour {smsModal.client}</h2>
                        <textarea value={smsModal.message} onChange={e => setSmsModal({ ...smsModal, message: e.target.value })} style={{ height: '150px' }} />
                        <div className="modal-actions">
                            <button onClick={() => setSmsModal({ ...smsModal, open: false })} className="btn-cancel">Fermer</button>
                            <button onClick={confirmSendSMS} className="btn-submit" disabled={smsSending}>
                                {smsSending ? "Envoi..." : "Envoyer"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
